<template>
  <div class="pageContent" style="  ">
    <pageTitle title='早餐券购买' />

    <div class="  text-align:center ; width:100% ; bor">
      <div style=" width:90% ; margin:auto ;  text-align:left ;  ">

        <div style='height: 0.2rem;'></div>

        <div style=" color: #333333; font-weight:bold; font-size: 0.3rem; ">
          {{ g_currentInfo.HotelName }}
        </div>
      </div>
      <!--border-bottom:1px solid #ddd ;-->
      <div style='border-bottom:1px solid #ddd ;  height: 0.2rem;'></div>

      <div style=" width:90% ; margin:auto ;  text-align:left ;   ">

        <div style=' height:0.2rem '></div>

        <table style=" color: #333333;  font-size: 0.26rem; width:100% ; text-align:center ">
          <tr>
            <td style="   ">
              <mu-date-picker style=' position:absolute ; width:2rem ; margin-left:-0.7rem  ' :maxDate="checkinMaxDate" :minDate="checkinMinDate" format='YYYY-MM-DD' :fullWidth='true' v-model="g_searchParam.startDate" :underlineShow='false' hintTextClass="date" inputClass="dpicker" @change="checkinDateChange" />
              <span style=" ">
                <small>开始</small><br/>{{checkInDateFormat}}
              </span>
            </td>
            <td style="width:1rem"> {{day}} 天 </td>
            <td style=" ">
              <mu-date-picker style=' position:absolute ; width:2rem ; margin-left:-0.7rem ; ' :maxDate="checkoutMaxDate" :minDate="checkoutMinDate" format='YYYY-MM-DD' :fullWidth='true' v-model='g_searchParam.endDate' :underlineShow='false' hintTextClass="date" inputClass="dpicker" @change="checkoutDateChange" />
              <small>结束</small><br/>{{checkOutDateFormat}}
            </td>
          </tr>
        </table>

        <div style=' height:0.2rem '></div>

      </div>

      <div class="greyline"></div>

      <div style=" width:90% ; margin:auto ;  text-align:left ; font-size:0.3rem ; color:#333   ">
        <div style=' height:0.2rem '></div>
        <span style=" font-size:0.3rem ; font-weight:bold; width: 40% ; display:inline-block;">
          早餐券价格：
        </span>
        <span style=" ">
          ￥ {{ BfPrice }} 元/份
        </span>
      </div>
      <div style=' height:0.2rem ;border-bottom:1px solid #eee;  '></div>

      <div style=" width:90% ; margin:auto ;  text-align:left ; font-size:0.3rem ; color:#333   ">
        <div style=' height:0.2rem '></div>
        <span style=" font-size:0.3rem ; font-weight:bold; width: 40% ; display:inline-block;">
          每日早餐券份数：
        </span>
        <span style=" ">
          <span class=" CanClick " v-bind:class=" { Cannot:BFCount == 1} " v-on:click="AddCount(-1)"> - </span>
          <span style=" padding:0 0.16rem ;  display:inline-block;  "> {{ BFCount }} </span>
          <span class=" CanClick " v-bind:class=" { Cannot:BFCount == 3} " v-on:click="AddCount(1)"> + </span>
        </span>
      </div>
      <div style=' height:0.2rem ;border-bottom:1px solid #eee;  '></div>

      <div style=" width:90% ; margin:auto ;  text-align:left ; font-size:0.3rem ; color:#333   ">
        <div style=' height:0.2rem '></div>
        <span style=" font-size:0.3rem ; font-weight:bold; width: 40% ; display:inline-block;">
          早餐券总价：
        </span>
        <span style=" ">
          ￥{{ BfPrice*BFCount*day }} 元
        </span>
      </div>
      <div style=' height:0.2rem ;border-bottom:1px solid #eee;  '></div>

    </div>

    <div style=' height:0.4rem '></div>

    <div v-on:click="InsertBreakfast()" style=' font-size:0.3rem ; color:white;  background-color:#27ba69 ; line-height: 0.8rem ;width:6.1rem ; border-radius:4px ; margin:auto; text-align:center; '>
      去支付
    </div>

    <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />

  </div>
</template>

<style >

</style>


<script>
import pageTitle from '../../components/pageTitle.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import date from '../../utils/dateextend.js'
import api from '../../api'

export default {
  data() {
    return {

      IsLoading:true,

      BfPrice: '',

      BFCount: 1,


      // 弹出层
      TellUser: '',
      toast: false,
      // 弹出标签 选择是否

    }
  },
  components: {
    swiper,
    swiperSlide,
    pageTitle,
  },


  activated() {

    this.IsLoading = true;

    // 获取价格
    this.GetServiceListByHotelCode();

    // 尝试获取外挂的参数
    if (this.$route.query.hotelcode != undefined) {
      var model = this.g_currentInfo;
      model.HotelCode = this.$route.query.hotelcode;
      this.setG_currentInfo(model);
    }

    var searchParam = this.g_searchParam;
    searchParam.startDate = new Date().DateAdd('d', 1).Format('yyyy-MM-dd');

    searchParam.endDate = searchParam.startDate;
    this.setG_searchParam(searchParam);
  },

  deactivated() {

    var searchParam = this.g_searchParam;
    searchParam.startDate = new Date(searchParam.startDate).DateAdd('d', -1).Format('yyyy-MM-dd');
    this.setG_searchParam(searchParam);
  },

  methods: {
    ...mapMutations({
      setG_searchParam: 'setG_searchParam', setG_currentInfo: 'setG_currentInfo',
      setRoom: 'setG_currentRoom', setDiscount: 'setG_currentDiscount',
      setG_PayOrder: 'setG_PayOrder'
    }),
    goback() {
      //  javascript: history.go(-1);
      this.$router.go(-1)
    },

    // 按钮调节
    AddCount(val) {
      this.BFCount = this.BFCount + val;

      if (this.BFCount == 0)
        this.BFCount = 1;
      else if (this.BFCount == 4)
        this.BFCount = 3;
    },



    // 获取  早餐价格
    GetServiceListByHotelCode() {



      if (this.g_UserInfo.Card_kind == undefined) {
        this.showToast('未登录');
        return
      }

      var params = new this.URLSearchParam();
      params.append('hotelCode', this.g_currentInfo.HotelCode);
      params.append('CardKind', this.g_UserInfo.Card_kind);

      this.$http.post(api.GetBreakFastMoneyByHotelCode(), params.toParam()).then((res) => {
        if (res.Result) {

          if (!res.Data.IsLogin) {
            this.showToast('未登录');
          }

          this.BfPrice = res.Data.BfPrice

          this.IsLoading = false;

        }
      })
    },


    InsertBreakfast() {

      if( this.IsLoading  ){
        this.showToast('请稍等~');
        return
      }

      this.IsLoading = true;

      var params = new this.URLSearchParam();
      params.append('hotelCode', this.g_currentInfo.HotelCode);
      params.append('countPerDay', this.BFCount);
      params.append('useStartDate', this.g_searchParam.startDate);
      params.append('useEndDate', this.g_searchParam.endDate);
      params.append('price', this.BfPrice);


      this.$http.post(api.InsertBreakfast(), params.toParam()).then((res) => {
        this.IsLoading = false;
        
        if (res.Result) {
          var Order = this.g_PayOrder;

          Order.Money = res.Data.totalMoney;
          Order.OrderId = res.Data.breakfastResvNo;
          this.setG_PayOrder(Order);

          this.showToast(res.Data.Msg);
          this.toastTimertoastTimer = setTimeout(() => { this.$router.push({ path: '/payOrder/breakfastPayType' }); }, 1900)
          // 名字要不一样，不然这个延时被覆盖掉了
        }
        else {
          this.showToast(res.Message);
        }
      })
    },









    checkoutDateChange(val) {
      //修改离店时间时只要修改离店时间，因为离店时间不可能小于入店时间
      this.reWriteQueryDate(this.g_searchParam.startDate, val);
    },
    checkinDateChange(val) {
      //修改入住时间后离店时间也修改
      this.reWriteQueryDate(val, new Date(val).DateAdd('d', 0).Format('yyyy-MM-dd'));
    },
    reWriteQueryDate(checkinDate, checkoutDate) {
      var searchParam = this.g_searchParam;
      searchParam.startDate = checkinDate;
      searchParam.endDate = checkoutDate;
      this.setG_searchParam(searchParam);
    },


    showToast(TellUser) {
      if (TellUser) {
        this.TellUser = TellUser
      }
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1600)
      if (this.TellUser == '未登录') {
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1900)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },


  },
  computed: {
    ...mapGetters([
      'g_currentInfo', 'g_searchParam', 'g_UserInfo', 'g_PayOrder'
    ]),








    day() {
      var d1 = new Date(this.g_searchParam.startDate)
      var d2 = new Date(this.g_searchParam.endDate)
      var s1 = d1.getTime(), s2 = d2.getTime();
      return parseInt((s2 - s1) / 1000 / (24 * 60 * 60)) + 1;
    },
    checkInDateFormat() {
      return new Date(this.g_searchParam.startDate).Format('M月D日')
    },
    checkOutDateFormat() {
      return new Date(this.g_searchParam.endDate).Format('M月D日')
    },
    checkinMinDate() {
      //最小入住日期为当天
      return new Date()
    },
    checkinMaxDate() {
      //最大入住日期为3个月内
      return new Date().DateAdd('d', 89)//入住日期最大为3个月内
    },
    checkoutMinDate() {
      //最小离店日期比当前入住时间多一天
      return new Date(this.g_searchParam.startDate).DateAdd('d', 1)
    },
    checkoutMaxDate() {
      //最大离店日期比当前入住时间多14天
      return new Date(this.g_searchParam.startDate).DateAdd('d', 14)
    },
  },


}
</script>





<style lang="less" scoped>
@import "../../assets/theme.less";


.CanClick {
  border-radius: 4px;
  border: 1px solid #ffa135;
  color: #ffa135;
  width: 0.42rem;
  height: 0.42rem;
  line-height: 0.38rem;
  text-align: center;
  display: inline-block;
}

.Cannot {
  border: 1px solid #ccc;
  color: #ccc;
}
</style>






// WEBPACK FOOTER //
// makeBreakfastOrder.vue?2c25e09b